exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".media-heading a[_v-5e5c22ca]{color:unset}.media-heading[_v-5e5c22ca]{font-weight:700}.am-nav-wrap[_v-5e5c22ca]{border-top:2px solid #337ab7;border-bottom:2px solid #337ab7}.am-nav-wrap h4[_v-5e5c22ca]{text-align:center}.am-nav-wrap .img-ga[_v-5e5c22ca]{padding:2px}.am-nav-wrap .image-link[_v-5e5c22ca]{text-align:center;display:block;margin-bottom:1em;color:#555}.expand-transition[_v-5e5c22ca]{transition:all .3s ease;padding:10px;overflow:hidden}.expand-enter[_v-5e5c22ca],.expand-leave[_v-5e5c22ca]{height:0;padding:0 10px;opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5e5c22ca&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/main/AmHeader.vue
// module id = 130
// module chunks = 0